import React from 'react';
import { twMerge } from 'tailwind-merge';

const Preamble = ({ value, className }) => {
	const cls = twMerge(
		'text-base font-bold leading-7 text-neutral-800 dark:text-white transition-colors',
		className
	);

	return (
		<div className={cls}>
			{value}
		</div>
	);
};

export default Preamble;